<template>
  <div>
    <h3>{{ $tr('responses.resume.title') }}</h3>
    <div>
      <div class="resume-title">{{ $tr('responses.resume.info') }}</div>
      <div class="row-block">
        <div>{{ $tr('responses.resume.name') }}</div>
        <div>{{ candidate.name }}</div>
      </div>
      <div class="row-block">
        <div>{{ $tr('responses.resume.surname') }}</div>
        <div>{{ candidate.surname }}</div>
      </div>
      <div class="row-block">
        <div>{{ $tr('responses.resume.email') }}</div>
        <div>
          <a :href="'mailto:' + candidate.email">{{ candidate.email }}</a>
        </div>
      </div>
      <div class="row-block">
        <div>{{ $tr('responses.resume.phone') }}</div>
        <div>{{ candidate.phone }}</div>
      </div>
      <div class="row-block">
        <div>{{ $tr('common.list.source') }}</div>
        <div>
          <span v-if="response.social_source">{{
            decodeURI(response.social_source) | parseSource
          }}</span>
          <span v-else>{{ response.source.name }}</span>
        </div>
      </div>
      <process-response-resume-additional-info :response="response" />
    </div>
  </div>
</template>

<script>
  export default {
    name: 'ResponseResumeScene',

    filters: {
      parseSource: function (value) {
        if (!value) return '';
        value = decodeURI(value.toString())
          .replace(/^https?\:\/\//i, '')
          .replace(/^www\./i, '');

        return value;
      }
    },

    props: {
      response: {
        type: Object,
        default: () => {}
      }
    },

    computed: {
      candidate() {
        return this.response.candidate || {};
      }
    }
  };
</script>

<style lang="scss" scoped>
  @import '@/styles/variables.scss';

  h3 {
    font-size: 24px;
  }
  .row-block {
    margin-bottom: 20px;
    display: flex;
    word-break: break-all;

    & > div {
      width: 66%;
    }

    & > div:first-child {
      font-weight: bold;
      width: 33%;
    }
  }
  .resume-title {
    margin-top: 20px;
    margin-bottom: 25px;
    color: $green;
    font-size: 18px;
  }
</style>
